import React from 'react';
import { BASE_URL } from '../../constant/api';
import { Link } from 'react-router-dom';

const CartTopProduct = ({ products, getCategoryName }) => {
  const ProductItem = ({ id, title, category, imageSrc }) => (
    <Link to={`/product-details/${id}`}>
      <div className="flex items-center space-x-4 p-2 bg-gray-100 rounded-md shadow-sm h-14 mt-2">
        <img src={imageSrc} alt={title} className="w-8 h-8 object-cover rounded-lg" />
        <div className="text-gray-700">
          <div className="text-xs font-semibold">{title}</div>
          <div className="text-xs text-gray-500">Category: {category}</div>
        </div>
      </div>
    </Link>
  );

  return (
    <div className="p-4 border-2 bg-white rounded-lg shadow-md flex flex-col sm:h-[400px] h-[350px]">
      <h3 className="text-xs font-semibold mb-4">Top Selling Products</h3>
      <div className="space-y-2 overflow-y-auto">
        {products.length > 0 ? (
          products.map((product) => {
            const categoryName = getCategoryName(product.category); // Get the category name
            return (
              <ProductItem
                key={product.id}
                id={product.id}
                title={product.name}
                category={categoryName}
                imageSrc={
                  product.product_images?.[0]?.image
                    ? product.product_images[0].image.startsWith(BASE_URL)
                      ? product.product_images[0].image
                      : `${BASE_URL}${product.product_images[0].image}`
                    : "/images/default-product.png"
                }
              />
            );
          })
        ) : (
          <p>No top selling products found!</p>
        )}
      </div>
    </div>
  );
};

export default CartTopProduct;

